export default __webpack_public_path__ + "static/044-447f608c2d8ac230301516a1e6d012d3.jpg";